import { DeviceTokenHelper } from '@/lib/helpers/device-token.helper'
import { encodeBase64Json } from '@/lib/utils/base64-json'
import { setCookie } from 'cookies-next'

export class AuthHelper {
  static saveDataAfterLogin(data: {
    token: string
    device_token: string
    user_info: { email: string; phone: string } | null
  }) {
    if (!data.token) {
      console.error('Token is not found')
      return
    }
    if (!data.device_token) {
      console.error('Device token is not found')
    }

    setCookie(process.env.NEXT_PUBLIC_TOKEN_KEY, data.token, {
      maxAge: 30 * 24 * 60 * 60, // 30 days
    })

    // chỉ lưu email và phone vào cookie
    const base64UserInfo = encodeBase64Json({
      email: data.user_info?.email,
      phone: data.user_info?.phone,
    })

    setCookie('user_info', base64UserInfo, {
      maxAge: 30 * 24 * 60 * 60, // 30 days
    })

    // Handle device token
    const currentDeviceToken = DeviceTokenHelper.get()
    if (!currentDeviceToken) {
      DeviceTokenHelper.set(data.device_token)
    }

    // Lưu ý: thiết lập Authorization header sẽ được thực hiện tại __c.auth.service
  }
}
